<div class="container-fluid p-3">

  <!-- Service Selection -->
  @if (additionalServices.length > 0) {
    <div class="row service-selection">
      <div class="col-md-4 p-0 service-selection-col">
        <mat-form-field appearance="outline" class="w-100">
          <mat-label>{{'ADDITIONAL_SERVICE_PLANNING.SELECT_ADDITIONAL_SERVICES' | transloco}}</mat-label>
          <mat-select [(value)]="selectedServiceId" (selectionChange)="onServiceChange($event.value)">
            @for (service of additionalServices; track service) {
              <mat-option [value]="service.id">
                {{service.name | translateAttribute}}
                @if (service.ordersCount && service.ordersCount > 0) {
                  <span class="order-count-badge">
                    ({{service.ordersCount}})
                  </span>
                }
              </mat-option>
            }
          </mat-select>
        </mat-form-field>
      </div>
      <!-- Service Information Section -->
      @if (selectedServiceId) {
        <div class="service-info-container">
          <div class="d-flex align-items-center gap-4">
            <div class="service-metric">
              <div class="metric-label">{{'ADDITIONAL_SERVICE_PLANNING.TOTAL_PRICE' | transloco}}</div>
              <div class="metric-value">{{allAdditionalServices.get(selectedServiceId)?.totalPrice || 0}} kr</div>
            </div>
            <div class="service-metric">
              <div class="metric-label">{{'ADDITIONAL_SERVICE_PLANNING.SERVICES_PER_DAY' | transloco}}
                <div class="metric-value">{{allAdditionalServices.get(selectedServiceId)?.servicesPerDay || 0}}</div>
              </div>
            </div>
            <div class="ms-auto mt-3 d-flex gap-2">
              <button mat-stroked-button (click)="openTimeSlotsModal()" color="secondary">
                <mat-icon>schedule</mat-icon>
                {{ 'ADDITIONAL_SERVICE_PLANNING.SCHEDULE_TEMPLATES' | transloco }}
              </button>
              <button mat-stroked-button (click)="openUnplannedTasksModal()" color="accent">
                <mat-icon>list_alt</mat-icon>
                {{ 'ADDITIONAL_SERVICE_PLANNING.SHOW_UNPLANNED_TASKS' | transloco }}
                @if (unplannedTasks.length > 0) {
                  <span class="ms-1">({{unplannedTasks.length}})</span>
                }
              </button>
              <button mat-stroked-button
                (click)="openEditAdditionalServiceModal(allAdditionalServices.get(selectedServiceId))" color="primary">
                <mat-icon>edit</mat-icon>
                {{ 'PRICING.ADDITIONAL_SERVICES.EDIT_ADDITIONAL_SERVICES' | transloco }}
              </button>
              <button mat-icon-button class="refresh-button" (click)="refreshData()" color="primary">
                <mat-icon>refresh</mat-icon>
              </button>
            </div>
          </div>
        </div>
      }
      <!-- Week Navigation -->
      @if (currentWeek) {
        <div class="row mb-3">
          <div class="col-12">
            <div class="d-flex justify-content-between align-items-center bg-light px-3 py-1 rounded">
              <button mat-icon-button (click)="goToPreviousWeek()" [disabled]="isLoading">
                <mat-icon>chevron_left</mat-icon>
              </button>
              <div class="d-flex align-items-center">
                <h5 class="mb-0 me-3">{{getWeekRangeText()}}</h5>
                <button mat-stroked-button (click)="goToCurrentWeek()" [disabled]="isLoading">
                  {{ 'ADDITIONAL_SERVICE_PLANNING.TODAY' | transloco }}
                </button>
              </div>
              <button mat-icon-button (click)="goToNextWeek()" [disabled]="isLoading">
                <mat-icon>chevron_right</mat-icon>
              </button>
            </div>
          </div>
        </div>
      }
      <!-- Weekly Calendar Grid -->
      @if (currentWeek && !isLoading) {
        <div class="calendar-container">
          <div class="row g-2">
            @for (day of currentWeek.days; track day) {
              <div class="col-lg col-md-3 col-sm-6 col-12"
                [class.inactive-day]="getTemplateKey(day)?.toLowerCase() == 'closed'"
                [class.active-day]="(getTemplateKey(day)?.toLowerCase() != 'closed')">
                <div class="day-column" [class.today]="day.isToday" [class.has-orders]="day.orders.length > 0"
                  [class.over-capacity-slot]="hasNonExistingTimeSlot(day.date)">
                  <!-- Day Header -->
                  <div class="day-header p-2 position-relative">
                  <div class="text-center">
                    <div class="day-name">
                      @if (translate.getActiveLang() === 'en') {
                        <span>{{day.dayName}}</span>
                      }
                      @if (translate.getActiveLang() === 'sv') {
                        <span>{{day.dayNameSv}}</span>
                      }
                    </div>
                    <div class="day-number" [class.today-number]="day.isToday">{{day.dayNumber}}</div>
                  </div>
                  <div class="services-capacity-row">
                    <div class="services-count">
                      <small>
                        {{day.orders.length}} / {{getTemplateCapacity(day.date, getTemplateKey(day))}} services
                        <span class="services-progress">
                        </span>
                      </small>
                    </div>
                    <div class="template-header">
                      <span class="template-status clickable" [matMenuTriggerFor]="statusMenu"
                        [matMenuTriggerData]="{day: day}"
                        [class.template-closed]="getTemplateKey(day)?.toLowerCase() == 'closed'"
                        [class.template-workday]="getTemplateKey(day)?.toLowerCase() != 'closed'">
                        {{ getTemplateLabel(day.templateStatus) }}
                        <mat-icon class="status-arrow">arrow_drop_down</mat-icon>
                      </span>
                    </div>
                  </div>
                </div>
                <!-- Slots Container -->
                <div class="orders-container">
                  <!-- Empty State -->
                  @if (day.orders.length === 0 && selectedServiceId) {
                    <div class="no-orders text-muted text-center p-3">
                      <small>{{'ADDITIONAL_SERVICE_PLANNING.NO_PLANNED_SERVICES' | transloco}}</small>
                      <small class="d-block mt-1">(0/{{getTemplateCapacity(day.date, getTemplateKey(day))}})</small>
                    </div>
                  }
                  <!-- Filled Slots (Orders) -->
                  @for (order of day.orders; track order; let i = $index) {
                    <div class="service-slot mb-2"
                      [class.over-capacity-slot]="i >= getTemplateCapacity(day.date, getTemplateKey(day))">
                      <div class="order-card p-2 cursor-pointer position-relative">
                        <div class="order-content" (click)="viewDetails(order)">
                          <button mat-icon-button class="edit-button position-absolute"
                            (click)="$event.stopPropagation(); editAdditionalService(order, $event)">
                            <mat-icon>edit</mat-icon>
                          </button>
                          <div class="order-heading">
                            <mat-icon class="me-1">directions_car</mat-icon>
                            <strong>{{order.regNo || 'No Reg'}}</strong>
                          </div>
                          <div class="order-details mt-1">
                            <span class="text-muted d-block">
                              <strong>#{{order.orderNr}}</strong>
                            </span>
                            <span class="text-muted d-block">
                              {{order.parkingName || 'No Parking'}} {{order?.parkingSite}}
                            </span>
                            <span class="text-muted d-flex align-items-center">
                              <mat-icon class="planned-time-icon d-flex align-items-center">alarm</mat-icon>
                              {{ (order.planned | date: 'HH:mm') || 'No fixed time'}}
                            </span>
                          </div>
                          <div class="status-badge mt-1" [ngClass]="'status-' + (order.status || 'unknown').toLowerCase()">
                            <span>{{order.status || 'N/A'}}</span>
                          </div>
                        </div>
                      </div>
                    </div>
                  }
                  <!-- Empty Slots (Placeholders) -->
                  @if (day.orders.length > 0 && selectedServiceId && day.orders.length < getTemplateCapacity(day.date, getTemplateKey(day))) {
                    @for (_ of [].constructor(getTemplateCapacity(day.date, getTemplateKey(day)) - day.orders.length); track _; let i = $index) {
                      <div
                        class="service-slot empty-slot mb-2">
                        <div class="empty-slot-placeholder"></div>
                      </div>
                    }
                  }
                </div>
              </div>
            </div>
          }
        </div>
      </div>
    } @else {
      @if (!isLoading && additionalServices.length === 0) {
        <div class="alert alert-warning">
          {{ 'ADDITIONAL_SERVICE_PLANNING.NO_ADDITIONAL_SERVICES_FOUND' | transloco }}
        </div>
      }
      @if (!isLoading && additionalServices.length > 0 && !selectedServiceId) {
        <div class="alert alert-info">
          {{ 'ADDITIONAL_SERVICE_PLANNING.SELECT_ADDITIONAL_SERVICE_TO_VIEW_CALENDAR' | transloco }}
        </div>
      }
    }
    <!-- Loading/Empty States -->
  </div>
}

<mat-menu #statusMenu="matMenu" class="p-0">
  <ng-template matMenuContent let-day="day">
    @for(item of additionalServiceTemplates; track item.id){
      <button mat-menu-item (click)="onScheduleTemplateSelected(day, item.name)">
        <span class="status-badge"
        [ngClass]="getTemplateKey(item.name)?.toLowerCase() == 'closed' ? 'template-closed' : 'template-workday'">{{ getTemplateLabel(item.name) }}</span>
      </button>
    }
  </ng-template>
</mat-menu>